import { PrimeReactProvider } from "primereact/api";
import { twMerge } from "tailwind-merge";
import "primeicons/primeicons.css";
import Configuration from "./pages/Configuration/Configuration";
import Layout from "./components/Layout/Layout";
import { Route, Routes, BrowserRouter } from "react-router-dom";
import AiPage from "./pages/AiPage/AiPage";
import Dashboard from "./pages/Dashboard/Dashboard";
import NegotiationRouter from "./pages/Negotiation/NegotiationRouter";
import { Evaluation } from "./pages/Evaluation/Evaluation";
import { HistoricalRun } from "./pages/Evaluation/HistoricalRun";
import Loader from "./components/Common/Loader/Loader";
import Login from "./pages/Login/Login";
function App() {

	return (
		<PrimeReactProvider
			value={{
				unstyled: false,
				ptOptions: {
					mergeSections: true,
					mergeProps: true,
					classNameMergeFunction: twMerge,
				},
			}}
		>
			<BrowserRouter>
				<Routes>
					{/* Login route - no defaultLayout */}
					<Route path="/login" element={<Login />} />
					{/* Routes with defaultLayout */}
					<Route path="/" element={<Layout />}>
						<Route index element={<Dashboard />} />
					</Route>
					<Route path="/configuration" element={<Layout />}>
						<Route index element={<Configuration />} />
					</Route>
					<Route path="/assessment" element={<Layout />}>
						<Route index element={<AiPage />} />
					</Route>
					<Route path="/evaluation" element={<Layout />}>
						<Route index element={<Evaluation />} />
						<Route path="runs/:runId" element={<HistoricalRun />} />
					</Route>

					{/* Dynamic negotiation routes */}
					<Route
						path="/negotiation-packages/:negotiation_id"
						element={<Layout />}
					>
						<Route index element={<NegotiationRouter />} />
					</Route>
					<Route
						path="/negotiation-packages/:negotiation_id/configure"
						element={<Layout />}
					>
						<Route index element={<Configuration />} />
					</Route>
					<Route
						path="/negotiation-packages/:negotiation_id/assessment"
						element={<Layout />}
					>
						<Route index element={<AiPage />} />
					</Route>
				</Routes>
				<Loader />
			</BrowserRouter>
		</PrimeReactProvider>
	);
}

export default App;
